import { TaiLieu } from "./TaiLieu";

export class QuaTrinhLamViec {
    "id": number;
    "idNhanVien": number;
    "ngayBatDau": Date;
    "ngayKetThuc": Date | null;
    "trangThai": number;
    "moTa": string;
    "idDonVi": number;
    "idChucVu": number;
    "idChucDanhChuyenMon": number;
    "idNhomNhanSu": number;
    "idLoaiQuyetDinh": number;
    "files": Array<any>;
    "dsTaiLieu": Array<TaiLieu>;
}

export class QuaTrinhLamViecRequest {
    "id": number;
    "idNhanVien": number;
    "ngayBatDau": Date;
    "ngayKetThuc": Date | null;
    "trangThai": number;
    "moTa": string;
    "idDonVi": number;
    "idChucVu": number;
    "idChucDanhChuyenMon": number;
    "idNhomNhanSu": number;
    "files": Array<any>;
    "idLoaiQuyetDinh": number;
    "idsTaiLieuQTLVXoa": Array<number>;
}

export class QuaTrinhLamViecReponse {
    "id": number;
    "idNhanVien": number;
    "soQD": string;
    "ngayKyQD": Date | null;
    "ngayBatDau": Date;
    "ngayKetThuc": Date | null;
    "trangThai": number;
    "moTa": string;
    "idDonVi": number;
    "idChucVu": number;
    "idChucDanhChuyenMon": number | null;
    "idNhomNhanSu": number | null;
    "tenDonVi": string;
    "tenChucVu": string;
    "tenChucDanhChuyenMon": string;
    "idLoaiQuyetDinh": number | null;
    "tenLoaiQuyetDinh": string;
    "dsTaiLieu": Array<TaiLieu>;
}
export class DanhGiaXepLoai {
    "id": number;
    "idNhanVien": number;
    "idKetQuaDanhGia": number;
    "tenKetQuaDanhGia": string;
    "ghiChu": string;
    "nam": number;
    "dsTaiLieu": Array<TaiLieu>;
}